import {client} from './services/client'

export  const balance_stories = {
    namespaced:true,
    state:{
        balance_stories:[],
        balanceloading:true,
        sumvente:0,
        searchResult:[],
    },
    mutations: {
        SET_BALANCE_STORIES (state,balance_stories){
            state.balance_stories = balance_stories
        },
        SET_BALANCELOADING (state,balance_stories){
            state.balanceloading = balance_stories
        },
        SET_SUMVENTE (state,balance_stories){
            state.sumvente = balance_stories
        },
        SET_searchResult (state,searchResult){
            state.searchResult= searchResult;
        },
    },
    actions: {
        get({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/balance_stories/get',
                })
                    .then((response)=>{
                        let balance_stories = response.data.balance_stories;
                        console.log("balance_stories",balance_stories);
                        commit('SET_BALANCE_STORIES',balance_stories)
                        commit('SET_BALANCELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getOne({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/balance_stories/get/'+id,
                })
                    .then((response)=>{
                        let balance_stories = response.data.balance_stories;
                        console.log(balance_stories);
                        commit('SET_BALANCE_STORIES',balance_stories)
                        commit('SET_BALANCELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getSumVente({commit},id){
            commit('SET_BALANCELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/balance_stories/getSumVente/'+id,
                })
                    .then((response)=>{
                        let balance_stories = response.data.balance_stories;
                        console.log(balance_stories);
                        commit('SET_SUMVENTE',balance_stories)
                        commit('SET_BALANCELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        searchVente({commit},data){
            commit('SET_BALANCELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/balance_stories/searchVente/',
                    data:data
                })
                    .then((response)=>{
                        let linex = response.data.linex;
                        let liney = response.data.liney;
                        console.log("line",[linex,liney]);
                        commit('SET_searchResult',[linex,liney])
                        commit('SET_BALANCELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

    },
    getters: {
        get: state  => {
            return state.balance_stories
        },
        search: state  => {
            return state.searchResult
        },
    }
};
